import React from 'react';
import { Tabs, Tab } from 'react-bootstrap/lib';
import ClientLendingResults from './ClientLendingResults';
import TrackingService from '../../services/TrackingService';

const LendingColumn = {
  INSTANT_APPROVAL: ['lendingInstantApproval', 'Clicked on Instant Approval'],
  PROTECTION_PLANS: ['lendingProtectionPlans', 'Protection Plans Selected'],
  ACCESSORIES: ['lendingAccessories', 'Accessories Selected'],
  CREDIT_APP: ['lendingCreditApplication', 'Credit App Completed'],
  APPROVAL_SEEN: ['lendingApprovalSeen', 'Total Approvals Viewed'],
  APPROVAL_SELECTED: ['lendingApprovalSelected', 'Loans Selected'],
  DOCUMENT_UPLOAD: ['lendingDocumentUpload', 'Documents Uploaded'],
};

const STORE_COLUMNS = [
  LendingColumn.PROTECTION_PLANS,
  LendingColumn.ACCESSORIES,
  LendingColumn.CREDIT_APP,
  LendingColumn.APPROVAL_SEEN,
  LendingColumn.APPROVAL_SELECTED,
];

const ONLINE_COLUMNS = [
  LendingColumn.INSTANT_APPROVAL,
  LendingColumn.PROTECTION_PLANS,
  LendingColumn.ACCESSORIES,
  LendingColumn.CREDIT_APP,
  LendingColumn.APPROVAL_SEEN,
  LendingColumn.APPROVAL_SELECTED,
  LendingColumn.DOCUMENT_UPLOAD,
];

export function LendingResults() {
  return (
    <Tabs id="lending-results" mountOnEnter unmountOnExit>
      <Tab eventKey={1} title="Store">
        <ClientLendingResults
          columns={STORE_COLUMNS}
          getMetrics={TrackingService.getStoreLendingMetrics}
        />
      </Tab>
      <Tab eventKey={2} title="Online">
        <ClientLendingResults
          getMetrics={TrackingService.getOnlineLendingMetrics}
          columns={ONLINE_COLUMNS}
        />
      </Tab>
    </Tabs>
  );
}

export default LendingResults;
